import {Injectable} from '@angular/core';
import {lastValueFrom, take} from 'rxjs';
import {UserService} from './user.service';
import {CreateNewAppUserGQL} from "../../../generated/graphql";
import {UserStorageService} from "./user.storage.service";
import {environment} from "../../../environments/environment";
import {CustomerServiceImpl} from "../customer/customer.service.impl";

@Injectable({providedIn: 'root'})
export class UserServiceImpl extends UserService {

  constructor(private createNewAppUserGQL: CreateNewAppUserGQL, private readonly userStorageService: UserStorageService) {
    super();
  }

  async createUserIfNotExists(): Promise<string> {
    const result = await lastValueFrom(this.createNewAppUserGQL.mutate({}, {
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
      context: {
        ignoreDefaultErrorHandling: true,
        headers: {
          'X-door-vision-app-user': this.userStorageService.getUserId() || '',
          'X-door-vision-customer-key': CustomerServiceImpl.GetCustomerKey(),
          'X-door-vision-version': environment.version
        }
      }
    }).pipe(take(1)))

    if (!result?.data?.createNewAppUser?.id) {
      throw new Error('Could not create user')
    }

    const userId = this.userStorageService.storeUserId(result.data.createNewAppUser.id);

    this.userStorageService.setUserIdValidated(true);

    return userId;
  }

  async getUserId(): Promise<string> {
    const userId = this.userStorageService.getUserId()
    if (!userId) {
      return this.createUserIfNotExists()
    }
    return userId
  }
}
